var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandardGameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 130,
    viewBox: "0 0 100 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_2635_777)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.1251,
    cy: 52.275,
    r: 22.275,
    fill: "#B158E7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2635_777)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.125,
    cy: 46.5,
    r: 16.5,
    fill: "#B158E7"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2635_777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2635_777",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 79,
    width: 53,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 124.691L24 109.966L35.6111 105.396L42.3843 122.66L35.6111 124.691Z",
    fill: "url(#paint0_linear_2635_777)",
    fillOpacity: 0.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3843 122.66L35.6111 105.396H64.6389L57.8657 122.66H42.3843Z",
    fill: "url(#paint1_linear_2635_777)",
    fillOpacity: 0.17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 105.396L50.125 79.5005L64.6389 105.396H35.6111Z",
    fill: "url(#paint2_linear_2635_777)",
    fillOpacity: 0.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 109.966L50.125 79.5005L35.6111 105.396L24 109.966Z",
    fill: "url(#paint3_linear_2635_777)",
    fillOpacity: 0.17
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.125 79.5005L76.25 109.966L64.6389 105.396L50.125 79.5005Z",
    fill: "url(#paint4_linear_2635_777)",
    fillOpacity: 0.17
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.25 109.966L64.6389 124.691L57.8657 122.66L64.6389 105.396L76.25 109.966Z",
    fill: "url(#paint5_linear_2635_777)",
    fillOpacity: 0.17
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 124.691L42.3843 122.66H57.8657L64.6389 124.691L50.125 126.25L35.6111 124.691Z",
    fill: "url(#paint6_linear_2635_777)",
    fillOpacity: 0.17
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2635_777)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 124.691L24 109.966L35.6111 105.396L42.3843 122.66L35.6111 124.691Z",
    fill: "#B158E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3843 122.66L35.6111 105.396H64.6389L57.8657 122.66H42.3843Z",
    fill: "#B158E7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 105.396L50.125 79.5005L64.6389 105.396H35.6111Z",
    fill: "#B158E7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24 109.966L50.125 79.5005L35.6111 105.396L24 109.966Z",
    fill: "#B158E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.125 79.5005L76.25 109.966L64.6389 105.396L50.125 79.5005Z",
    fill: "#B158E7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.25 109.966L64.6389 124.691L57.8657 122.66L64.6389 105.396L76.25 109.966Z",
    fill: "#B158E7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 124.691L42.3843 122.66H57.8657L64.6389 124.691L50.125 126.25L35.6111 124.691Z",
    fill: "#B158E7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 124.691L24 109.966L35.6111 105.396L42.3843 122.66L35.6111 124.691Z",
    fill: "url(#paint7_linear_2635_777)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3843 122.66L35.6111 105.396H64.6389L57.8657 122.66H42.3843Z",
    fill: "url(#paint8_linear_2635_777)",
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 105.396L50.125 79.5005L64.6389 105.396H35.6111Z",
    fill: "url(#paint9_linear_2635_777)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 109.966L50.125 79.5005L35.6111 105.396L24 109.966Z",
    fill: "url(#paint10_linear_2635_777)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.125 79.5005L76.25 109.966L64.6389 105.396L50.125 79.5005Z",
    fill: "url(#paint11_linear_2635_777)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25 109.966L64.6389 124.691L57.8657 122.66L64.6389 105.396L76.25 109.966Z",
    fill: "url(#paint12_linear_2635_777)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 124.691L42.3843 122.66H57.8657L64.6389 124.691L50.125 126.25L35.6111 124.691Z",
    fill: "url(#paint13_linear_2635_777)",
    style: {
      mixBlendMode: "soft-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.5
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.0253,
    cy: 30.87,
    r: 1.14492,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.2231,
    cy: 25.141,
    r: 0.915932,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 31.2406,
    cy: 28.1659,
    r: 0.915932,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.6035,
    cy: 21.5468,
    r: 0.457966,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 57.3447,
    cy: 17.8813,
    r: 0.457966,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 51.8491,
    cy: 7.81051,
    r: 0.457966,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 38.3393,
    cy: 13.9936,
    r: 0.228983,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 45.2095,
    cy: 0.253885,
    r: 0.228983,
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1481 28.4341L26 41.978L37.1481 46.1813L43.6512 30.3022L37.1481 28.4341Z",
    fill: "#B158E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6512 30.3022L37.1481 46.1813H65.0185L58.5154 30.3022H43.6512Z",
    fill: "#B158E7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1481 46.1813L51.0833 70L65.0185 46.1813H37.1481Z",
    fill: "#B158E7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41.978L51.0833 70L37.1481 46.1813L26 41.978Z",
    fill: "#B158E7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0833 70L76.1667 41.978L65.0185 46.1813L51.0833 70Z",
    fill: "#B158E7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1667 41.978L65.0185 28.4341L58.5154 30.3022L65.0185 46.1813L76.1667 41.978Z",
    fill: "#B158E7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1481 28.4341L43.6512 30.3022H58.5154L65.0185 28.4341L51.0833 27L37.1481 28.4341Z",
    fill: "#B158E7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.1481 28.4341L26 41.978L37.1481 46.1813L43.6512 30.3022L37.1481 28.4341Z",
    fill: "url(#paint14_linear_2635_777)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6512 30.3022L37.1481 46.1813H65.0185L58.5154 30.3022H43.6512Z",
    fill: "url(#paint15_linear_2635_777)",
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1481 46.1813L51.0833 70L65.0185 46.1813H37.1481Z",
    fill: "url(#paint16_linear_2635_777)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 41.978L51.0833 70L37.1481 46.1813L26 41.978Z",
    fill: "url(#paint17_linear_2635_777)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0833 70L76.1667 41.978L65.0185 46.1813L51.0833 70Z",
    fill: "url(#paint18_linear_2635_777)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1667 41.978L65.0185 28.4341L58.5154 30.3022L65.0185 46.1813L76.1667 41.978Z",
    fill: "url(#paint19_linear_2635_777)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1481 28.4341L43.6512 30.3022H58.5154L65.0185 28.4341L51.0833 27L37.1481 28.4341Z",
    fill: "url(#paint20_linear_2635_777)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2635_777",
    x: 0.350098,
    y: 2.5,
    width: 99.5498,
    height: 99.5498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.75,
    result: "effect1_foregroundBlur_2635_777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2635_777",
    x: 14.375,
    y: 10.75,
    width: 71.5,
    height: 71.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.625,
    result: "effect1_foregroundBlur_2635_777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2635_777",
    x: 21.1675,
    y: 76.668,
    width: 57.915,
    height: 52.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.41625,
    result: "effect1_foregroundBlur_2635_777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2635_777",
    x1: 50.125,
    y1: 96.5505,
    x2: 50.125,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2635_777",
    x1: 50.125,
    y1: 96.5505,
    x2: 50.125,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2635_777",
    x1: 50.125,
    y1: 96.5505,
    x2: 50.125,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2635_777",
    x1: 50.125,
    y1: 96.5505,
    x2: 50.125,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2635_777",
    x1: 50.125,
    y1: 96.5505,
    x2: 50.125,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2635_777",
    x1: 50.125,
    y1: 96.5505,
    x2: 50.125,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2635_777",
    x1: 50.125,
    y1: 96.5505,
    x2: 50.125,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2635_777",
    x1: 42.2875,
    y1: 122.675,
    x2: 34.9052,
    y2: 105.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2635_777",
    x1: 50.125,
    y1: 123.202,
    x2: 50.125,
    y2: 105.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2635_777",
    x1: 50.125,
    y1: 105.416,
    x2: 50.125,
    y2: 79.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2635_777",
    x1: 35.6111,
    y1: 105.416,
    x2: 51.2092,
    y2: 80.1704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2635_777",
    x1: 65.1125,
    y1: 105.213,
    x2: 49.0603,
    y2: 80.1833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2635_777",
    x1: 57.3819,
    y1: 123.71,
    x2: 65.2676,
    y2: 105.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2635_777",
    x1: 50.125,
    y1: 125.707,
    x2: 50.125,
    y2: 122.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2635_777",
    x1: 43.5583,
    y1: 30.2882,
    x2: 36.9659,
    y2: 45.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2635_777",
    x1: 51.0833,
    y1: 29.8043,
    x2: 51.0833,
    y2: 46.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2635_777",
    x1: 51.0833,
    y1: 46.163,
    x2: 51.0833,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2635_777",
    x1: 37.1481,
    y1: 46.163,
    x2: 51.2119,
    y2: 69.9239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2635_777",
    x1: 65.4732,
    y1: 46.35,
    x2: 50.9816,
    y2: 69.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2635_777",
    x1: 58.0509,
    y1: 29.337,
    x2: 65.0924,
    y2: 46.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2635_777",
    x1: 51.0833,
    y1: 27.5,
    x2: 51.0833,
    y2: 30.2717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardGameIcon);
export default __webpack_public_path__ + "static/media/standard-game-icon.7e33be398c29f0d1340840cc25a461f1.svg";
export { ForwardRef as ReactComponent };